import { injectCpmsBoTransactionReportsOverviewStatisticsApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-transaction-reports-overview-statistics.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoTransactionReportsOverviewStatisticsApi =
  injectCpmsBoTransactionReportsOverviewStatisticsApi(baseApi);

export const { useCpmsBoGetOverviewStatisticsQuery } =
  cpmsBoTransactionReportsOverviewStatisticsApi;
